import styled, { css } from 'styled-components';

export const ExpandableCardsSection = styled.div`
  border-radius: ${({ theme }) => theme.radius.s};
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
`;

export const ExpandableCardsContainer = styled.div`
  height: ${({ theme }) => theme.height.h7};
  padding: ${({ theme }) => `0 ${theme.spacing.m}`};
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const ExpandableCardsContent = styled.div(
  ({ theme, height, backgroundColorDetail = 'white' }) => css`
    max-height: ${height};
    overflow: hidden;
    transition: max-height 0.6s ease;
    background-color: ${theme.colors[backgroundColorDetail]};
  `
);

export const ExpandableCardsTitle = styled.div(
  ({ width }) => css`
    width: ${width}%;
  `
);

export const ExpandableCardExpandArrow = styled.div``;

export const DescriptionTitleContainer = styled.div`
  padding: ${({ theme }) =>
    `0 ${theme.spacing.m} ${theme.spacing.m} ${theme.spacing.m}`};
`;
